// Импортируем React и хук 'useState' для управления состоянием полей формы.
import React, { useState } from 'react';

// Импортируем библиотеку для отправки email. Она должна быть предварительно установлена (npm install @emailjs/browser).
import emailjs from '@emailjs/browser';

// Импортируем модульные стили для этого компонента.
import styles from './ContactSection.module.css';

// Определяем наш главный компонент для секции контактов.
const ContactSection = () => {
  // --- СОСТОЯНИЯ КОМПОНЕНТА ---

  // Создаем состояние для хранения данных из всех полей формы.
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    phone: '',
    email: '',
    message: '',
  });

  // Создаем состояние для отслеживания статуса отправки формы.
  const [formStatus, setFormStatus] = useState('');

  // --- ОБРАБОТЧИКИ СОБЫТИЙ ---

  // Единая функция для обработки изменений во всех полях ввода (input, textarea).
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Функция, которая вызывается при отправке формы (нажатии на кнопку).
  const handleSubmit = (e) => {
    // Предотвращаем стандартное поведение браузера - перезагрузку страницы.
    e.preventDefault();

    // Меняем статус на "отправка", чтобы пользователь видел, что процесс пошел.
    setFormStatus('sending');

    // Вызываем метод .sendForm() из библиотеки EmailJS для отправки письма.
    emailjs.sendForm(
      'service_745e05r',      // Ваш SERVICE ID
      'template_gffy3js',     // Ваш TEMPLATE ID
      e.target,               // Ссылка на DOM-элемент формы
      'RH8R2vJxzC_HNl-Yh'     // Ваш PUBLIC KEY
    )
    .then((result) => {
        // Этот блок кода выполнится, если письмо отправлено УСПЕШНО.
        console.log('SUCCESS!', result.text);
        setFormStatus('success');
        setFormData({ name: '', company: '', phone: '', email: '', message: '' });
        setTimeout(() => setFormStatus(''), 5000);
    }, (error) => {
        // Этот блок кода выполнится, если при отправке произошла ОШИБКА.
        console.log('FAILED...', error.text);
        setFormStatus('error');
        setTimeout(() => setFormStatus(''), 5000);
    });
  };

  // --- JSX-РАЗМЕТКА (То, что видит пользователь) ---
  return (
    <section id="contact" className={styles.contactSection}>
      <div className={`container ${styles.container}`}>
        {/* Левая колонка с контактной информацией */}
        <div className={styles.infoColumn}>
          <h2 className={styles.title}>Свяжитесь с нами</h2>
          <p className={styles.description}>
            Оставьте заявку, и наш специалист свяжется с вами в течение 15 минут, 
            чтобы ответить на все вопросы и подобрать лучший БРУ для ваших нужд.
          </p>
          <ul className={styles.contactList}>
            <li><strong>Адрес:</strong> Алматы, Казахстан (демо)</li>
            <li><strong>Телефон:</strong> <a href="tel:+77771234567">+7 (777) 123-45-67</a></li>
            <li><strong>Email:</strong> <a href="mailto:info@bru.kz">info@bru.kz</a></li>
          </ul>
        </div>

        {/* Правая колонка с самой формой */}
        <div className={styles.formColumn}>
          <form onSubmit={handleSubmit} className={styles.contactForm}>
            <div className={styles.inputGroup}>
              {/* 
                Теги <input> являются "самозакрывающимися" в JSX,
                поэтому они должны заканчиваться на '/>'.
              */}
              <input type="text" name="name" placeholder="Ваше имя *" value={formData.name} onChange={handleChange} required />
              <input type="text" name="company" placeholder="Название компании" value={formData.company} onChange={handleChange} />
            </div>
            <div className={styles.inputGroup}>
              <input type="tel" name="phone" placeholder="Ваш телефон *" value={formData.phone} onChange={handleChange} required />
              <input type="email" name="email" placeholder="Ваш Email *" value={formData.email} onChange={handleChange} required />
            </div>
            <textarea name="message" placeholder="Опишите ваш проект или задайте вопрос..." rows="5" value={formData.message} onChange={handleChange}></textarea>
            
            <button type="submit" className={styles.submitButton} disabled={formStatus === 'sending'}>
              {formStatus === 'sending' ? 'Отправка...' : 'Отправить заявку'}
            </button>
            
            {/* Блоки для отображения статуса отправки */}
            {formStatus === 'success' && <p className={styles.statusMessageSuccess}>Спасибо! Ваша заявка успешно отправлена.</p>}
            {formStatus === 'error' && <p className={styles.statusMessageError}>Произошла ошибка. Попробуйте позже.</p>}
          </form>
          <p className={styles.spamNotice}>
            Нажимая "Отправить заявку", вы соглашаетесь с политикой конфиденциальности. 
            Мы не занимаемся спамом.
          </p>
        </div>
      </div>
    </section>
  );
};

// Экспортируем компонент для использования в других частях приложения.
export default ContactSection;